import axios, { AxiosError } from "axios";
import { IProblemDetails } from "models/IProblemDetails";

export const isProblemDetails = (error: Error): error is AxiosError<IProblemDetails> =>
    axios.isAxiosError(error)
    && Object.hasOwnProperty.call(error.response?.data, "type")
    && Object.hasOwnProperty.call(error.response?.data, "status");
